import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as PaperclipIcon } from './paperclip.svg';

export const Paperclip = IconHOC(PaperclipIcon);
